import React from "react";
import { Navigate} from "react-router-dom";

import {APICore} from "../helpers/api/apiCore";
import {useSyncedPermissions} from "../helpers/can";

/**
 * Private Route forces the authorization before the route can be accessed
 * @param {*} param0
 * @returns
 */
const PrivateRoute = ({children, permissions, ...rest}: any) => {
    // Rebuilds the CAN() ability from live auth state DURING this render, so
    // every gated control below reads the current permission set. Without it a
    // grant that arrived after a component's last render stayed invisible —
    // after login an inventory list showed no action icons until a reload.
    // Hooks run before any conditional return below.
    const livePermissions = useSyncedPermissions();
    // `children` is a referentially STABLE element (route.element, built once in
    // routes/index.tsx), so re-rendering this component does NOT re-render it —
    // React sees an identical element and bails out of the subtree. Keying on the
    // permission set is what forces the gated children to pick up new rules.
    // Recomputed only when the permission array identity changes.
    const signature = React.useMemo(() => livePermissions.join("|"), [livePermissions]);

    const api = new APICore();
    if (!api.isUserAuthenticated()) {
        // not logged in so redirect to login page with the return url
        return (
            <Navigate
                // state={from: props['path']}
                to={{
                    pathname: "/auth/login",
                    // state: { from: props['path'] },
                }}
            />
        );
    }

    const loggedInUser = api.getLoggedInUser();
    // check if route is restricted by role
    if (permissions && permissions.length > 0 && !permissions?.some((item: string) => loggedInUser?.permission?.includes(item))) {
        // role not authorised so redirect to login page
        return <Navigate to={{pathname: "/"}}/>;
    }

    return <React.Fragment key={signature}>{children}</React.Fragment>;
};

export default PrivateRoute;
